import { METRICS } from '../../metrics/constants';
import { FEATURE_NAMES } from '../../features/constants';

export const webVitals = {
  enabled: false,
  auto_instrument: false,
  harvester: false,
  sampling: 1.0,
  features_required: [FEATURE_NAMES.sessionTrace],
  mapped_attributes: {
    required: [
      METRICS.CLS,
      METRICS.FCP,
      METRICS.FID,
      METRICS.INP,
      METRICS.LCP,
      METRICS.TTFB,
    ],
  },
};
